import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import {capitalize} from 'util/NameUtil';

export default function TranslationLinkInvalidationWarningModal({
  onRequestClose,
  onRequestSubmit,
  isDeletion,
  count,
}: {
  onRequestClose: () => void;
  onRequestSubmit: (shouldProceed: boolean) => void;
  isDeletion: boolean;
  count: number;
}): JSX.Element {
  let ctaStyle;
  const translationSubject = pluralize(count, 'translation');
  if (isDeletion) {
    ctaStyle = ButtonStyle.NEGATIVE;
  } else {
    ctaStyle = ButtonStyle.PRIMARY;
  }

  // This modal could be triggered by a change in the start codon coercion so keep the copy generic.
  const operationVerb = isDeletion ? 'delete' : 'edit';
  const operationHeader = `${capitalize(operationVerb)} ${translationSubject}`;
  const warningCopy = `This operation ${operationVerb}s a translation using a non-standard genetic code or with its start codon translated as methionine. Continuing may invalidate existing translation links.`;

  return (
    <Modal
      title={`${operationHeader}?`}
      medium={true}
      buttons={[
        {
          text: 'Cancel',
          cancel: true,
          onClick: () => {
            onRequestSubmit(false);
          },
        },
        {
          text: operationHeader,
          submit: true,
          style: ctaStyle,
          onClick: () => {
            onRequestSubmit(true);
          },
        },
      ]}
      onRequestClose={onRequestClose}
    >
      {warningCopy}
    </Modal>
  );
}
